<template>
  <v-container>
    <v-stepper v-model="stepper">
      <v-stepper-header>
        <v-stepper-step
          step="1"
          :complete="stepper > 1"
        >
          ログインIDの確認
        </v-stepper-step>
        <v-divider />
        <v-stepper-step
          step="2"
          :complete="stepper > 2"
        >
          送信先の選択
        </v-stepper-step>
        <v-divider />
        <v-stepper-step
          step="3"
          :complete="stepper > 3"
        >
          送信完了
        </v-stepper-step>
      </v-stepper-header>

      <v-stepper-items>
        <v-stepper-content step="1">
          <forget-login-id
            v-if="user"
            :user="user"
            :enable-login-button="enableLoginButton"
            @toNextStep="nextStep"
          />
        </v-stepper-content>
        <v-stepper-content step="2">
          <forget-select-send
            v-if="user"
            :user="user"
            :enable-login-button="enableLoginButton"
            @toNextStep="nextStep"
            @toBackStep="backStep"
          />
        </v-stepper-content>
        <v-stepper-content step="3">
          <forget-completed
            v-if="user"
            :user="user"
            :enable-login-button="enableLoginButton"
          />
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
  </v-container>
</template>

<script>
import ForgetLoginId from './forms/_LoginId'
import ForgetSelectSend from './forms/_SelectSend'
import ForgetCompleted from './forms/_Completed'
export default {
  name: 'ForgetIndex',
  components: {
    ForgetLoginId,
    ForgetSelectSend,
    ForgetCompleted
  },
  mixins: [],
  props: {},
  data() {
    return {
      stepper: 1,
      enableLoginButton: true,
      user: {
        login_id: null,
        email: null,
        mobile_number: null
      }
    }
  },
  computed: {},
  watch: {},
  created() {
    if ('sp' in this.$route.query) {
      this.enableLoginButton = false
    }
  },
  methods: {
    nextStep () {
      this.stepper++
    },
    backStep () {
      this.stepper--
    },
  }
}
</script>

<style scoped>

</style>
